<template>
    <div class="home-page" v-if="token !== ''">
        <Sidebar></Sidebar>
        <router-view></router-view>
    </div>
</template>

<script>

import Sidebar from './Sidebar.vue';

export default {
    components: {
        Sidebar,
    },
    computed: {
        token() {
            return this.$store.getters['authentication/getToken'];
        },
    },
    mounted(){
        this.$store.dispatch('setting/fetchAll');
    }
};

</script>

<style lang="scss">
    @import '../../style/layout/HomePage.scss';
</style>
